export default {
  // Register
  register: {
    createAccount: 'Crear cuenta',
    createAccountDescription: 'Cree una cuenta para ver los cursos aprobados en su estado.',
    firstName: 'NOMBRE',
    lastName: 'APELLIDO',
    emailAddress: 'CORREO ELECTRÓNICO',
    username: 'USUARIO',
    usernameFilledFromEmail:
      'El nombre de usuario se ha establecido igual que su correo. Puede cambiarlo si lo desea.',
    password: 'CONTRASEÑA',
    confirmPassword: 'CONFIRMAR CONTRASEÑA',
    company: 'EMPRESA',
    next: 'Siguiente',
    country: 'PAÍS',
    address: 'DIRECCIÓN',
    address2: 'DIRECCIÓN #2',
    city: 'CIUDAD',
    state: 'ESTADO',
    zipCode: 'CÓDIGO POSTAL',
    phone: 'TELÉFONO',
    fax: 'FAX',
    selectOption: 'Seleccione opción',
    additionalInformation: 'INFORMACIÓN ADICIONAL',
    education: 'EDUCACIÓN',
    experience: 'EXPERIENCIA',
    gender: 'GÉNERO',
    birthYear: 'AÑO DE NACIMIENTO',
    howDidYouHear: '¿CÓMO SE ENTERÓ DE NOSOTROS?',
    goBack: 'Volver',
    submit: 'Enviar',
    fixErrorsBelow: 'Por favor corrija lo siguiente:',
    userType: 'YO SOY',
    userTypeOptions: {
      homeowner: 'Propietario',
      professional: 'Profesional',
      both: 'Ambos'
    },
    // Dropdown option labels (Education)
    educationOptions: {
      highSchool: 'Escuela secundaria',
      someCollege: 'Algo de universidad',
      associateDegree: 'Título de asociado',
      bachelorDegree: 'Licenciatura',
      masterOrGreater: 'Maestría o mayor',
      other: 'Otro'
    },
    // Experience
    experienceOptions: {
      lessThan1Year: 'Menos de 1 año',
      oneToFiveYears: '1-5 años',
      sixToTenYears: '6-10 años',
      tenYearsOrMore: '10 años o más'
    },
    // How did you hear about us
    howDidYouHearOptions: {
      radioAd: 'Anuncio de radio',
      printAd: 'Anuncio impreso',
      tvAd: 'Anuncio de TV',
      directedByAgency: 'Dirigido por otra agencia',
      recommendedByFriend: 'Recomendado por un amigo',
      work: 'Trabajo',
      other: 'Otro'
    },
    // Gender
    genderOptions: {
      male: 'Masculino',
      female: 'Femenino',
      other: 'Otro',
      preferNotToSay: 'Prefiero no decir'
    }
  },

  // Forgot Password / Account Lookup
  forgotPassword: {
    accountLookup: 'Búsqueda de cuenta',
    instruction: 'Ingrese la dirección de correo electrónico de su cuenta. Las instrucciones de inicio de sesión se le enviarán por correo electrónico.',
    noEmailOnFile:
      'Si no tiene una dirección de correo electrónico en el archivo, contacte a su administrador de capacitación local para obtener ayuda con el inicio de sesión. Si no sabe quién es su administrador local, también puede enviarnos un correo a ',
    forAssistance: ' para obtener ayuda.',
    email: 'CORREO ELECTRÓNICO:',
    send: 'Enviar'
  },

  // Login
  login: {
    pleaseSignIn: 'Por favor inicie sesión',
    username: 'USUARIO:',
    password: 'CONTRASEÑA:',
    submit: 'Enviar',
    forgotUsernameOrPassword: '¿Olvidó su usuario o contraseña?',
    dontHaveAccount: '¿No tiene una cuenta?',
    createAccount: 'Crear cuenta'
  },

  // Header
  header: {
    professional: 'Profesional',
    homeowner: 'Propietario de vivienda',
    about: 'Acerca de',
    events: 'Eventos',
    training: 'Capacitación',
    grants: 'Subvenciones',
    logIn: 'Iniciar sesión',
    createAccount: 'Crear cuenta',
    dashboard: 'Panel',
    enEspanol: 'In English'
  },

  // Sidebar
  sidebar: {
    info: 'Info/Información',
    contactUs: 'Contáctenos',
    whatsNew: 'Novedades',
    community: 'Comunidad',
    eventsCalendar: 'Calendario de eventos'
  },

  // 404 / Page Not Found (Safe Dig Indiana)
  notFound: {
    maintenanceMessage: 'Disculpe las molestias — estamos trabajando bajo la superficie. ¡Vuelva pronto para nuestra nueva experiencia de aprendizaje!'
  },

  // Footer
  footer: {
    copyright: 'Los materiales de este sitio web tienen derechos de autor ©{year} de la Comisión Reguladora de Servicios Públicos de Indiana.',
    allRightsReserved: 'Todos los derechos reservados. Todos los derechos no expresamente otorgados aquí están reservados.'
  },

  // Homeowners page (hero carousel)
  homeownersPage: {
    heroWelcomeTitle: '¡Bienvenidos, propietarios!',
    heroWelcomeSubtitle: 'Regístrese e inicie sesión para acceder a su capacitación de seguridad gratuita',
    loginRegister: 'Iniciar sesión / Registrarse',
    heroSmellGasTitle: '¿Huele a gas? ¡Actúe rápido!',
    heroSmellGasSubtitle: '¿Sabe qué hacer si huele gas natural?',
    learnMore: 'Más información',
    heroPlantingTitle: '¿Plantando un árbol? ¿Cerca? ¿Buzón nuevo?',
    heroPlantingSubtitle: 'Nunca se sabe qué hay debajo. Llame al 811 antes de trabajar',
    indiana811: 'Indiana 811'
  },

  // Professionals page
  professionalsPage: {
    learnMore: 'Más información',
    requestDigTicket: 'Solicitar su boleto de excavación',
    requestDigTicketDescription: 'Su primera parada cuando se prepara para excavar.',
    onlineTicketEntry: 'Entrada de boleto en línea',
    heroWelcomeTitle: '¡Bienvenido, profesional de servicios públicos!',
    heroWelcomeSubtitle: 'Regístrese e inicie sesión para acceder a su capacitación de seguridad gratuita.',
    loginRegister: 'Iniciar sesión / Registrarse',
    viewCourse: 'Ver curso'
  },

  // Homepage
  homepage: {
    welcomeTo: 'Bienvenido a',
    safeDigIndiana: 'Safe Dig Indiana',
    heroText: 'La Comisión Reguladora de Servicios Públicos de Indiana, a través de la Cuenta de Protección de Instalaciones Subterráneas, se dedica a reducir los daños a las instalaciones subterráneas y mantener a los Hoosiers conectados de manera segura a sus servicios públicos a través de capacitación, divulgación y educación.',
    pleaseSelectYourPage: 'POR FAVOR SELECCIONE SU PÁGINA',
    professionals: 'PROFESIONALES',
    homeowners: 'PROPIETARIOS DE VIVIENDA',
    accessYourTraining: 'ACCEDA A SU CAPACITACIÓN',
    helpfulLinks: 'ENLACES ÚTILES',
    notify811: 'Notify 811',
    notify811Description: 'Su primera parada cuando se prepara para excavar.',
    siteProfessionals: 'Profesionales',
    homeownersLabel: 'Propietarios de vivienda',
    pipelineDamagesMap: 'Mapa de daños a tuberías',
    pipelineDamagesMapDescription: 'Vea capacitaciones de seguridad de servicios públicos, reuniones y otros eventos',
    useTheMap: 'Usar el mapa',
    eventsCalendar: 'Calendario de eventos',
    eventsCalendarDescription: 'Vea capacitaciones de seguridad de servicios públicos, reuniones y otros eventos',
    upcomingEvents: 'Próximos eventos'
  },

  // Contact Us
  contactUs: {
    title: 'Si tiene alguna pregunta sobre el sitio, contáctenos.',
    intro: 'La IURC está aquí para ayudar con cualquier pregunta sobre el contenido del curso o para aclarar preguntas sobre las leyes de excavación.',
    toContactIurc: 'Para contactar a la IURC:',
    email: 'Correo electrónico:',
    importantLegalInfo: 'Información legal importante',
    overview: 'Resumen',
    overviewText: 'Al utilizar este sitio web, acepta estar sujeto a estos términos de uso. La Comisión Reguladora de Servicios Públicos de Indiana puede modificar estos términos en cualquier momento. La IURC se reserva el derecho de buscar todos los recursos disponibles en derecho y equidad por violaciones de estos términos.',
    copyrightInfo: 'Información de derechos de autor',
    copyrightText: 'Todo el contenido de este sitio web está protegido por las leyes y tratados de derechos de autor de Estados Unidos e internacionales. Ninguna parte del sitio web puede ser copiada, alterada, distribuida, transmitida, interpretada, exhibida o utilizada de ninguna manera sin el permiso previo por escrito de la Comisión Reguladora de Servicios Públicos de Indiana.',
    trademarkTitle: 'Información sobre marcas registradas',
    trademarkText: 'Los nombres y logotipos de Safe Dig Indiana y todos los nombres de productos y servicios relacionados son marcas o marcas registradas de la Comisión Reguladora de Servicios Públicos de Indiana y son propiedad de la Comisión Reguladora de Servicios Públicos de Indiana.',
    useOfInfoTitle: 'Uso de la información',
    useOfInfoText: 'La Comisión Reguladora de Servicios Públicos de Indiana por la presente le autoriza a ver, copiar, imprimir y distribuir los materiales disponibles en este sitio web siempre que (1) los materiales se utilicen únicamente con fines informativos internos no comerciales; (2) el aviso de derechos de autor anterior aparezca en cada copia del material y de cualquier parte del mismo; y (3) no se modifiquen o alteren de ninguna manera los materiales o gráficos relacionados. Cualquier derecho no expresamente otorgado en este documento se reserva por la Comisión Reguladora de Servicios Públicos de Indiana.',
    complianceTitle: 'Cumplimiento de las leyes aplicables',
    complianceText: 'Todas las leyes federales, estatales y locales aplicables rigen el acceso de los usuarios a este sitio web.',
    disclaimerTitle: 'Exención de garantía',
    disclaimerText: 'Aunque la Comisión Reguladora de Servicios Públicos de Indiana intenta proporcionar información útil, la Comisión Reguladora de Servicios Públicos de Indiana no asume ninguna responsabilidad por la exactitud o integridad de la información ni por la idoneidad de cualquier asesoramiento, opinión, declaración u otra información mostrada o distribuida a través de este sitio web. Esta información podría contener inexactitudes técnicas o errores tipográficos, y la información puede ser modificada, actualizada y eliminada sin previo aviso. Además, la Comisión Reguladora de Servicios Públicos de Indiana no asume ninguna obligación de actualizar o continuar publicando la información. TODA LA INFORMACIÓN PROPORCIONADA EN O A TRAVÉS DE ESTE SITIO WEB SE PROPORCIONA "TAL CUAL" SIN GARANTÍAS DE NINGÚN TIPO, YA SEAN EXPRESAS O IMPLÍCITAS.',
    limitationTitle: 'Limitación de responsabilidad',
    limitationText: 'EN NINGÚN CASO LA COMISIÓN REGULADORA DE SERVICIOS PÚBLICOS DE INDIANA SERÁ RESPONSABLE ANTE NINGUNA PARTE POR DAÑOS DIRECTOS, INDIRECTOS, INCIDENTALES, ESPECIALES, CONSECUENTES O PUNITIVOS POR EL USO DE ESTE SITIO, INCLUYENDO, SIN LIMITACIÓN, PÉRDIDA DE GANANCIAS O INGRESOS, COSTOS DE PRODUCTOS DE REEMPLAZO, INTERRUPCIONES COMERCIALES, PÉRDIDA DE DATOS O DAÑOS RESULTANTES DEL USO O LA CONFIANZA EN LA INFORMACIÓN PRESENTADA.',
    jurisdictionTitle: 'Jurisdicción',
    jurisdictionText: 'La Comisión Reguladora de Servicios Públicos de Indiana controla y opera este sitio web a través de su proveedor en el estado de Indiana. La Comisión Reguladora de Servicios Públicos de Indiana no implica que los materiales publicados en este sitio web sean apropiados para su uso fuera de Indiana. Si accede a este sitio web desde fuera de Indiana, lo hace por su propia iniciativa y es responsable del cumplimiento de las leyes locales. Los términos de este sitio web se regirán por las leyes del estado de Indiana.',
    revisionsTitle: 'Revisiones',
    revisionsText: 'La Comisión Reguladora de Servicios Públicos de Indiana puede terminar, cambiar, suspender o discontinuar cualquier aspecto de este sitio web, incluida la disponibilidad de cualquier función del sitio, en cualquier momento y sin previo aviso. La Comisión Reguladora de Servicios Públicos de Indiana se reserva el derecho, a su sola discreción, de cambiar, modificar, agregar o eliminar cualquier parte de estos términos en su totalidad o en parte, en cualquier momento y sin previo aviso. La Comisión Reguladora de Servicios Públicos de Indiana puede terminar la autorización, los derechos y la licencia otorgados anteriormente en cualquier momento y sin previo aviso. Su uso continuado de este sitio web después de que se publiquen los cambios en estos términos se considerará aceptación de dichos cambios.',
    consentsTitle: 'Consentimientos',
    consentsTextBefore: 'Las solicitudes de consentimientos o aprobaciones de la Comisión Reguladora de Servicios Públicos de Indiana deben hacerse por escrito y dirigirse a',
    consentsTextAfter: 'o:',
    consentsAddress: 'Indiana Utility Regulatory Commission\nAttention: Beth Heline, General Counsel\n101 West Washington Street, Suite 1500 E\nIndianapolis, IN 46204'
  },

  // Community / Associations
  community: {
    title: 'Asociaciones',
    associations: {
      iurc: 'Comisión Reguladora de Servicios Públicos de Indiana (IURC)',
      cga: 'Common Ground Alliance (CGA)',
      uppa: 'Cuenta de Protección de Instalaciones Subterráneas (UPPA)',
      holidaySchedule: 'Calendario de días festivos de Indiana 811',
      indiana811: 'Indiana 811',
      damagePreventionCouncils: 'Consejos de prevención de daños de Indiana (DPC)',
      damageToUnderground: 'Daños a instalaciones subterráneas',
      inpaa: 'Asociación de concientización sobre tuberías de Indiana (INPAA)'
    }
  },

  // What's New
  whatsNew: {
    title: 'Novedades',
    welcomeTitle: 'Bienvenido a Safe Dig Indiana',
    welcomePara1: '¡Bienvenido al sistema de capacitación de seguridad de servicios públicos en línea gratuito de Indiana!',
    welcomePara2: 'La Comisión Reguladora de Servicios Públicos de Indiana ha creado este recurso de capacitación gratuito para cualquier persona que trabaje en excavación para aprender más sobre cómo trabajar de manera segura en Indiana. Actualmente, los cursos disponibles enseñarán a los excavadores sobre la Ley de excavación de Indiana y cómo esa ley afecta su lugar de trabajo, incluyendo cómo funciona el sistema 811 y cómo usar 811 de la manera más eficiente.',
    welcomePara3: 'Asegúrese de visitar la sección de Recursos para obtener más información que pueda ayudarlo a mantenerse seguro y mantener su trabajo en curso. Se le anima a imprimir y conservar cualquier información que crea que puede ayudar a mantener sus trabajos de manera segura y eficiente.',
    welcomePara4Before: 'Vuelva con frecuencia para ver las nuevas actualizaciones de los recursos disponibles y las nuevas oportunidades de capacitación. Si tiene una sugerencia sobre contenido que le gustaría ver agregado, comuníquese con la IURC ',
    welcomePara4After: '.',
    contactHere: 'aquí'
  },

  // Events
  events: {
    title: 'Calendario de eventos',
    pageTitle: 'Eventos',
    intro: 'Vea capacitaciones de seguridad de servicios públicos, reuniones y otros eventos.',
    noEventsMessage: 'No hay eventos programados en este momento.',
    daysShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
    months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
  },

  // Grants
  grants: {
    heroTitle: 'El fondo UPPA',
    heroSubtitle: '¿Tiene una idea que mejoraría la seguridad de los servicios públicos? ¡Solicite una subvención del fondo UPPA!',
    intro: 'La Subvención de la Cuenta UPP está disponible para cualquier persona que busque mejorar la seguridad de las comunidades de Indiana mediante la protección de instalaciones subterráneas a través de: concientización pública, capacitación y educación, o programas de incentivos.',
    completingApplication: 'Completar la solicitud',
    downloadInstruction: 'Descargue la {appLink} y las {instructionsLink} usando los enlaces a continuación.',
    uppaGrantApp: 'Solicitud de subvención de la Cuenta UPP',
    uppaGrantInstructions: 'Instrucciones de solicitud de subvención de la Cuenta UPP',
    btnGrantApp: 'SOLICITUD DE SUBVENCIÓN UPPA',
    btnGrantInstructions: 'INSTRUCCIONES DE SOLICITUD DE SUBVENCIÓN UPPA',
    note: 'Cuando envíe su solicitud de subvención, no envíe como PDF.',
    fillOutFields: 'Por favor complete todos los campos en la mayor medida posible. La fecha de inicio de cualquier evento propuesto debe ser posterior a la fecha en que envíe la solicitud. Las solicitudes para eventos que ya hayan ocurrido podrían no ser aprobadas.',
    questionsDirectTo: 'Las preguntas sobre su solicitud deben dirigirse al Gerente del Programa del Fondo de la Cuenta de Protección de Instalaciones Subterráneas Darby Miller en {email}. Las preguntas legales pueden dirigirse a la Oficina del Consejo General en {legalEmail}.',
    completedTo: 'Las solicitudes completadas deben enviarse por correo electrónico al Gerente del Programa de la Cuenta de Protección de Instalaciones Subterráneas, en {email}.',
    grantingOfFunds: 'Otorgamiento de fondos',
    grantingPara1: 'Su finalización de esta solicitud de subvención no garantiza que la IURC otorgue fondos de subvención. Si la IURC proporciona una subvención, lo hará por escrito. La IURC hará todo lo posible por responder a las solicitudes dentro de treinta días.',
    grantingPara2: 'Los solicitantes deberán celebrar un acuerdo de subvención completamente ejecutado antes de la provisión de fondos de la Cuenta de Protección de Instalaciones Subterráneas.',
    grantingPara3: 'Tenga en cuenta que debido a las reglas de contratación estatal, no es necesario un acuerdo de subvención para subvenciones de $5,000 o menos. Sin embargo, la IURC aún requiere una solicitud de subvención completa y aprobada.',
    grantingPara4: 'Para poder pagar una subvención o contrato, el solicitante debe estar registrado en el sistema de pagos del Estado de Indiana. Esto requerirá un formulario W-9 y de depósito directo correctamente completados.',
    clickHere: 'Haga clic aquí',
    clickHereLink: '{link} para ser dirigido a la página de Solicitud de subvención de la IURC para los formularios W-9 y de depósito directo más actualizados.'
  }
};
